module.exports = "<div class=\"user-view view\" *ngIf=\"user\">\n  <h1>User : {{user.username}}</h1>\n  <ul class=\"meta\">\n    <li><span class=\"label\">Created:</span> {{user.created | timeago}}</li>\n    <li *ngIf=\"user.location\"><span class=\"label\">Location:</span> {{user.location}}</li>\n  </ul>\n  <p class=\"links\">\n    <a href=\"http://{{user.website}}\" target=\"_blank\" *ngIf=\"user.website\">website</a>\n    <a href=\"https://{{user.twitter}}\" *ngIf=\"user.twitter\">Twitter</a>\n    <a href=\"https://{{user.github}}\" *ngIf=\"user.github\">GitHub</a>\n  </p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/user/user.component.html
// module id = 166
// module chunks = 1